import React from "react";

/**
 * ContentOptions component that provides a flexible content container with responsive sizing
 * Supports both regular and small layout variants with different column widths
 * 
 * @param {Object} props - Component props
 * @param {ReactNode} props.children - Child components to render inside the container
 * @param {boolean} props.small - Whether to use small layout variant (default: false)
 *                                Small: col-xl-3 col-lg-3 with contentoptions-small class
 *                                Regular: col-lg-6 standard width
 */
const ContentOptions = ({ children, small }) => (
    <div
        className={`contentoptions ${small ? "col-xl-3 col-lg-3 contentoptions-small" : "col-lg-6"} background-content-gray d-flex flex-column`}
    >
        {children}
    </div>
);

export default ContentOptions;
